import { styles } from "../services/variables.js";

function showStyles(e, btnStyles, stylesLink, stylesTitle, stylesShow) {
	if (
		!e.closest(btnStyles) &&
		!e.classList.contains(stylesLink) &&
		!e.classList.contains(stylesTitle)
	) {
		styles.classList.remove(stylesShow);
	} else if (e.closest(btnStyles)) {
		styles.classList.add(stylesShow);
	}
}

export default showStyles;
